import Vue from 'vue'

Vue.filter('f_currency', function (value) {
        if (typeof value !== 'number') return '-'
        let formatter = new Intl.NumberFormat('zh-CN', {
            style: 'currency',
            currency: 'CNY',
        });
        return formatter.format(value/100);
});

Vue.filter('f_businessStatus', function (value) {
    const statuses = {
        0: '待跟进',
        1: '跟进中',
        2: '已到店',
        3: '已签约',
        4: '进件中',
        5: '审核失败',
        6: '审核通过',
        7: '已发放',
        8: '已完结',
        9: '已终止',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_loanPurpose', function (value) {
    const statuses = {
        1: '综合消费',
        2: '生产经营',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_qualificationLabel', function (value) {
    const statuses = {
        1: '资质较差',
        2: '资质一般',
        3: '资质良好',
    };
    return statuses[value] || '资质未标记';
});

Vue.filter('f_productType', function (value) {
    const statuses = {
        1: '信用贷',
        2: '车抵贷',
        3: '房抵贷',
        4: '消费贷',
        5: '企业贷',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_channelType', function (value) {
    const statuses = {
        0: '平台推广',
        1: '机构私有',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_occupation', function (value) {
    const statuses = {
        1: '上班族',
        2: '个体户',
        3: '企业主',
        4: '自由职业',
        5: '公务员',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_incomeForm', function (value) {
    const statuses = {
        1: '银行代发',
        2: '现金',
        3: '自存',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_creditOverdue', function (value) {
    const statuses = {
        1: '无逾期记录',
        2: '有逾期记录已结清',
        3: '有逾期未结清',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_sesameScore', function (value) {
    const statuses = {
        1: '600分以下',
        2: '600~650分',
        3: '650~700分',
        4: '700分以上',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_followUpMethod', function (value) {
    const statuses = {
        1: '电话',
        2: '微信',
        3: '短信',
        4: '现场',
        5: '其他',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_followUpLabel', function (value) {
    const statuses = {
        1: '联系方式无效',
        2: '拒接沟通',
        3: '无需求',
        4: '需求模糊可挖掘',
        5: '需求明确',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_accountType', function (value) {
    const statuses = {
        0: '机构管理员',
        1: '团队管理员',
        2: '业务员',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_authStatus', function (value) {
    const statuses = {
        0: '未认证',
        1: '认证中',
        2: '已认证',
        3: '认证失败',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_subscriptionStatus', function (value) {
    const statuses = {
        0: '未订阅',
        1: '订阅有效',
        2: '订阅过期',
        3: '订阅终止',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_subscriptionVersion', function (value) {
    const statuses = {
        1: '入门版',
        2: '专业版',
        3: '旗舰版',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_transSubject', function (value) {
    const statuses = {
        0: '钱包充值',
        1: '推广预算支付',
        2: '推广超预算补扣',
        3: '推广未消耗退回',
        4: '销户退款',
        5: '平台赠送',
        6: '平台划扣',
        7: '推广终止剩余退回',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_distributionType', function (value) {
    const statuses = {
        0: '自动分配',
        1: '手动分配',
    };
    return statuses[value] || '未知';
});

Vue.filter('f_channelRating', function (value) {
    const statuses = {
        0: 'A类特级',
        1: 'B类优质',
        2: 'C类普通',
    };
    return statuses[value] || '未知';
});




// WEBPACK FOOTER //
// ./src/filters.js